import AxiosInterceptor from "../utils/AxiosInterceptor";
import { API_BASE } from "../utils/constants";

export const apiAuth = {
  resetPassword: (value) =>
    AxiosInterceptor().post(API_BASE + "/update-password", value),
  getAdminDetails: (value) =>
    AxiosInterceptor().get(API_BASE + "/getAdminDetails", value),
  updateAdminProfile: (value) =>
    AxiosInterceptor().post(API_BASE + "/editProfile", value),
  changePassword: (value) =>
    AxiosInterceptor().post(API_BASE + "/changePassword", value),
  getSetting: (value) =>
    AxiosInterceptor().get(API_BASE + "/getSetting", value),
  updateSetting: (value) =>
    AxiosInterceptor().post(API_BASE + "/updateSetting", value),
  getAllCountry: (value) =>
    AxiosInterceptor().get(API_BASE + "/getAllCountries", value),
  updateCountry: (value) =>
    AxiosInterceptor().post(API_BASE + "/updateCountries", value),
  changeStatus: (value) =>
    AxiosInterceptor().post(API_BASE + "/changeStatusLanguage", value),
  getAll: (value) =>
    AxiosInterceptor().post(API_BASE + "/getAllLanguages", value),
};

export const userServices = {
  getUser: (values) => AxiosInterceptor().post(`/getAllUser`, values),
  getById: (values) => AxiosInterceptor().get(`/getUser/${values?.id}`),
  add: (values) => AxiosInterceptor().post(`/addUser`, values),
  edit: (value) => AxiosInterceptor().post(`/updateUser`, value),
  deleteUser: (value) => AxiosInterceptor().post(`/deleteUser`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/changeUserStatus`, value),
  approveRejectWithdrawal: (value) =>
    AxiosInterceptor().post(`/approveRejectWithdrawal`, value),
};

export const LeagueManagementService = {
  getBids: (values) => AxiosInterceptor().post(`/getAllLeagues`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneLeague/${values.id}`),
  deleteBid: (value) => AxiosInterceptor().post(`/deleteLeague`, value),
  changeStatus: (value) =>
    AxiosInterceptor().post(`/changeLeagueStatus`, value),
  getCountry: () => AxiosInterceptor().get("/countries"),
};

export const contestServices = {
  // contestServices
  add: (values) => AxiosInterceptor().post(`/addContest`, values),
  edit: (values) => AxiosInterceptor().post(`/updateContest`, values),
  getAllLeagues: (values) => AxiosInterceptor().post(`/getAllLeagues`, values),
  getContest: (values) => AxiosInterceptor().post(`/getAllContests`, values),
  getById: (values) => AxiosInterceptor().get(`/getOneContest/${values.id}`),
  deleteContest: (value) => AxiosInterceptor().post(`/deleteContest`, value),
  changeStatus: (value) =>
    AxiosInterceptor().post(`/changeContestStatus`, value),
  getLeaderboard: (value) => AxiosInterceptor().post(`/getLeaderboard`, value),
  getAllFantasyGames: (value) =>
    AxiosInterceptor().post(`/getAllFantasyGames`, value),
  countMatchTimeWise: (values) =>
    AxiosInterceptor().post(`/countMatchTimeWise`, values),
  getMatchesByDate: (values) =>
    AxiosInterceptor().post(`/getMatchesByDate`, values),
  getFantasyGameTeamById: (values) =>
    AxiosInterceptor().get(`/getFantasyGameTeamById/${values.id}`),
};

export const emailServices = {
  // Email
  getEmail: (values) => AxiosInterceptor().post(`/getAllTemplate`, values),
  addEmail: (value) => AxiosInterceptor().post(`/addTemplate`, value),
  getByIdEmail: (values) =>
    AxiosInterceptor().get(`/getOneTemplate/${values.id}`),
  editEmail: (value) => AxiosInterceptor().post(`/updateTemplate`, value),
  deleteEmail: (value) => AxiosInterceptor().post(`/deleteTemplate`, value),
  changeStatusEmail: (value) => AxiosInterceptor().post("/changeStatus", value),
};

export const apiCategory = {
  add: (value) => AxiosInterceptor().post(`/category/category`, value),
  edit: (value) => AxiosInterceptor().post(`/category/update-category`, value),
  delete: (value) =>
    AxiosInterceptor().post(`/category/delete-category`, value),
  getAll: (values) => AxiosInterceptor().post(`/category/categories`, values),
  getById: (values) =>
    AxiosInterceptor().post(`/category/single-category`, values),
  changeStatus: (value) =>
    AxiosInterceptor().post("/category/update-status", value),
  getAllSubCategory: (values) =>
    AxiosInterceptor().post(`/subcategory/getAllSubcategories`, values),
  addSubCategory: (value) =>
    AxiosInterceptor().post(`/subcategory/add-subcategory`, value),
  editSubCategory: (value) =>
    AxiosInterceptor().post(`/subcategory/edit-subcategory`, value),
  deleteSubCategory: (value) =>
    AxiosInterceptor().post(`/subcategory/delete-subcategory`, value),
  getByIdSubCategory: (values) =>
    AxiosInterceptor().post(`/subcategory/get-by-id`, values),
  changeStatusSubCategory: (value) =>
    AxiosInterceptor().post("/subcategory/update-status", value),
};

export const apiCms = {
  add: (value) => AxiosInterceptor().post(`/create`, value),
  edit: (value) => AxiosInterceptor().post(`/updateContent`, value),
  delete: (value) => AxiosInterceptor().post(`/delete`, value),
  getAll: (values) => AxiosInterceptor().post(`/getAllContent`, values),
  getById: (values) =>
    AxiosInterceptor().get(`/getOneContent/${values.id}`, values),
  changeStatus: (value) => AxiosInterceptor().post("/update-status", value),

  // Faq
  getFaq: (values) => AxiosInterceptor().post(`/getAllFaqs`, values),
  addFaq: (value) => AxiosInterceptor().post(`/addFaqs`, value),
  getByIdFaq: (values) => AxiosInterceptor().get(`/getOneFaq/${values.id}`),
  editFaq: (value) => AxiosInterceptor().post(`/updateFaqs`, value),
  deleteFaq: (value) => AxiosInterceptor().post(`/deleteFaq`, value),
  changeStatusFaq: (value) =>
    AxiosInterceptor().post("/changeStatusFaq", value),
};

export const apiHowToplay = {
  getAll: (values) => AxiosInterceptor().post(`/getAllHowToPlays`, values),
  add: (value) => AxiosInterceptor().post(`/addHowToPlay`, value),
  getById: (values) => AxiosInterceptor().get(`/getOneHowToPlay/${values.id}`),
  edit: (value) => AxiosInterceptor().post(`/updateHowToPlays`, value),
  delete: (value) => AxiosInterceptor().post(`/deleteHowToPlay`, value),
  changeStatus: (value) => AxiosInterceptor().post("/changeStatusHTP", value),
};

export const apiJackpotService = {
  getAll: (values) => AxiosInterceptor().post(`/getAllJackpot`, values),
  add: (value) => AxiosInterceptor().post(`/addJackpot`, value),
  getById: (values) => AxiosInterceptor().get(`/getOneJackpot/${values.id}`),
  edit: (value) => AxiosInterceptor().post(`/updateJackpot`, value),
  delete: (value) => AxiosInterceptor().post(`/deleteJackpot`, value),
  changeStatus: (value) => AxiosInterceptor().post("/changeStatusHTP", value),
  selectWinners: (value) => AxiosInterceptor().post("/selectWinners", value),
  getAllContestUsers: (value) =>
    AxiosInterceptor().post("/getAllContestUsers", value),
  getContest: () => AxiosInterceptor().get("/getContest"),
  getUsers: (value) => AxiosInterceptor().post("/getusers", value),
};

export const teamManagementApi = {
  getAll: (values) => AxiosInterceptor().post(`/getAllPlayers`, values),
  getById: (values) => AxiosInterceptor().get(`/getOnePlayers/${values.id}`),
  edit: (value) => AxiosInterceptor().post(`/updatePlayers`, value),
  getPlayer: (value) => AxiosInterceptor().post(`/getAllTeams`, value),
};

export const DashboardApi = {
  getAll: () => AxiosInterceptor().get("/getDashboardReports"),
  getRevenue: () => AxiosInterceptor().get("/getRevenueAnalytics"),
};

export const gameManagementApi = {
  getById: (value) => AxiosInterceptor().get(`/getOneGame/${value.id}`),
  getAllGames: (value) => AxiosInterceptor().post(`/getAllGames`, value),
  edit: (value) => AxiosInterceptor().post(`/updateGame`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/changeGameStatus`, value),
};

export const walletServices = {
  getUser: (values) => AxiosInterceptor().post(`/getAllUser`, values),
  getByIdTransation: (values) =>
    AxiosInterceptor().get(`/get-trxn/${values?.id}`),
  add: (values) => AxiosInterceptor().post(`/addUser`, values),
  edit: (value) => AxiosInterceptor().post(`/updateUser`, value),
  deleteUser: (value) => AxiosInterceptor().post(`/deleteUser`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/changeUserStatus`, value),
  getusertransaction: (values) =>
    AxiosInterceptor().post(`/user-transaction`, values),
  getAllWithdrawalRequest: (values) =>
    AxiosInterceptor().post(`/all-withdrawl-pending-request`, values),
  withdrawlRequest: (values) =>
    AxiosInterceptor().post(`/withdrawl-request`, values),
  updateWallet: (value) => AxiosInterceptor().post(`/updateUserWallet`, value),
};

export const gamePointManagementApi = {
  getAll: (values) => AxiosInterceptor().post(`/getAllFantasyPoints`, values),
  getById: (values) =>
    AxiosInterceptor().get(`/getOneFantasyPoints/${values?.id}`),
  add: (values) => AxiosInterceptor().post(`/addFantasyPoints`, values),
  edit: (value) => AxiosInterceptor().post(`/updateFantasyPoints`, value),
  deleteUser: (value) => AxiosInterceptor().post(`/deleteFantasyPoints`, value),
  changeStatus: (value) => AxiosInterceptor().post(`/changeUserStatus`, value),
  getusertransaction: (values) =>
    AxiosInterceptor().post(`/user-transaction`, values),
  pointStatus: (values) =>
    AxiosInterceptor().post(`/changeScoringStatus`, values),
};

export const RevenueApi = {
  getTotalRevenue: (value) => AxiosInterceptor().post("/totalRevenue", value),
};

export const ReferralManagementApi = {
  getAll: (values) =>
    AxiosInterceptor().post(`/getAllUsersWithReferral`, values),
  getById: (values) =>
    AxiosInterceptor().get(`/getUserReferralDetails/${values?.id}`),
};

export const notificationManagementApi = {
  getAllNotification: (values) =>
    AxiosInterceptor().post(`/notification/getAllTemplate`, values),
  getByIdNotification: (values) =>
    AxiosInterceptor().get(`/notification/getOneTemplate/${values.id}`),
  editNotification: (value) =>
    AxiosInterceptor().post(`/notification/updateTemplate`, value),
  changeStatusNotificaton: (value) =>
    AxiosInterceptor().post("/notification/changeStatus", value),
  addNotification: (value) =>
    AxiosInterceptor().post(`/notification/addTemplate`, value),
};

export const friendModalListApi = {
  getUserFriendList: (values) =>
    AxiosInterceptor().post(`/getUserFriendList`, values),
};

export const AboutUsApi = {
  update: (value) => AxiosInterceptor().post(`/createOrUpdateAboutUs`, value),
  getById: (values) => AxiosInterceptor().get(`/getAboutUs`, values),
};

export const ChatApi = {
  getChatHistory: (value) =>
    AxiosInterceptor().post(`/getChatHistoryByUserId`, value),
  getChatPersonsList: (values) =>
    AxiosInterceptor().post(`/getChatPersonsList`, values),
  deleteMessage: (values) =>
    AxiosInterceptor().post(`/deleteMessageById/${values?.id}`),
  deleteChat: (value) =>
    AxiosInterceptor().post(`/deleteChatHistoryWithUser`, value),
};

export const boostersServices = {
  getAllBooster: (values) => AxiosInterceptor().post(`/getAllBoosters`, values),
  getOneBoosters: (values) =>
    AxiosInterceptor().get(`/getOneBoosters/${values.id}`),
  updateBoosters: (value) => AxiosInterceptor().post(`/updateBoosters`, value),
  deleteEmail: (value) => AxiosInterceptor().post(`/deleteTemplate`, value),
  changeBoosterStatus: (value) =>
    AxiosInterceptor().post("/changeBoosterStatus", value),
};

export const ResponsibleGamblingApi = {
  getResponsibleGamblingById: (values) =>
    AxiosInterceptor().get(`/getResponsibleGamblingById`, values),
  update: (value) =>
    AxiosInterceptor().post(`/updateResponsibleGambling`, value),
};

export const getLeagueRoundsWithMatches = {
  getLeagueRounds: (values) =>
    AxiosInterceptor().post(`/getLeagueRoundsWithMatches`, values),
};
